<template>
  <div class="content-dashboard">
    <div class="d-flex align-items-center justify-content-between">
      <h3>Factures clients</h3>
      <!-- <a href="#" class="btn btn-orange font-bold" @click.prevent="downloadAll">
        <i class="ti ti-download"></i> Télécharger
      </a> -->
    </div>

    <!-- <h4 class="mt-4 mb-4 font-15">{{ factureClientStore.TotalItems || 0 }} factures</h4> -->

    <div class="mt-3 d-flex align-items-center justify-content-between mb-4">
      <div class="d-flex gap-3">
        <a
          href="#"
          class="btn btn-outline-orange"
          :class="{
            'btn-orange': factureClientStore.sortBy === 'Par_PiDt' || factureClientStore.sortBy === 'Par_PiDt_Desc',
          }"
          @click.prevent="
            factureClientStore.changeSort(factureClientStore.sortBy === 'Par_PiDt' ? 'Par_PiDt_Desc' : 'Par_PiDt')
          "
        >
          <i
            class="ti ti-calendar orange-color pe-2"
            :class="{
              'icon-white': factureClientStore.sortBy === 'Par_PiDt' || factureClientStore.sortBy === 'Par_PiDt_Desc',
            }"
          ></i>
          Date de commande
          <i
            class="ti"
            :class="{
              'ti-arrow-up': factureClientStore.sortBy === 'Par_PiDt',
              'ti-arrow-down': factureClientStore.sortBy === 'Par_PiDt_Desc',
              'icon-white': factureClientStore.sortBy === 'Par_PiDt' || factureClientStore.sortBy === 'Par_PiDt_Desc',
            }"
          ></i>
        </a>
        <a
          href="#"
          class="btn btn-outline-orange"
          :class="{
            'btn-orange': factureClientStore.sortBy === 'Par_HtMt' || factureClientStore.sortBy === 'Par_HtMt_Desc',
          }"
          @click.prevent="
            factureClientStore.changeSort(factureClientStore.sortBy === 'Par_HtMt' ? 'Par_HtMt_Desc' : 'Par_HtMt')
          "
        >
          <i
            class="ti ti-receipt orange-color pe-2"
            :class="{
              'icon-white': factureClientStore.sortBy === 'Par_HtMt' || factureClientStore.sortBy === 'Par_HtMt_Desc',
            }"
          ></i>
          Montant
          <i
            class="ti"
            :class="{
              'ti-arrow-up': factureClientStore.sortBy === 'Par_HtMt',
              'ti-arrow-down': factureClientStore.sortBy === 'Par_HtMt_Desc',
              'icon-white': factureClientStore.sortBy === 'Par_HtMt' || factureClientStore.sortBy === 'Par_HtMt_Desc',
            }"
          ></i>
        </a>
      </div>
      <div class="d-flex justify-content-end mb-3">
        <button class="btn-view me-2" :class="{ active: view === 'grid' }" @click="view = 'grid'">
          <i class="ti ti-layout-grid2"></i>
        </button>
        <button class="btn-view" :class="{ active: view === 'list' }" @click="view = 'list'">
          <i class="ti ti-menu"></i>
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div v-if="factureClientStore.getIsLoading" class="text-center py-3">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-3">Chargement des factures...</p>
    </div>
    <!-- No Invoices -->
    <div v-else-if="!factureClientStore.getFacturesClients.length" class="alert alert-info">
      Aucune facture trouvée.
    </div>

    <!-- Grid View -->
    <div v-else-if="view === 'grid'" class="row">
      <div class="col-lg-4" v-for="item in factureClientStore.getFacturesClients" :key="item.PINO">
        <div class="gray-box d-block facture-box">
          <p class="mb-1 dark-color font-15">{{ formatDate(item.PiDt) }}</p>
          <div class="d-flex gap-2 align-items-center mb-2">
            <i class="ti ti-receipt blue-color font-30"></i>
            <div class="gray-box-info">
              <p class="font-bold mb-0">{{ `Facture N° ${item.PIREF}` || `Facture N° ${item.PINO}` }}</p>
              <span class="font-bold">{{ formatPrice(item.TTCMT) }}€ TTC</span>
            </div>
          </div>
          <a
            href="#"
            class="btn btn-outline-orange"
            :class="{ disabled: downloading[item.PINO] }"
            @click.prevent="downloadFactureClients(item.PINO, item.PREFPINO, item.PIREF || item.PINO)"
          >
            <i v-if="downloading[item.PINO]" class="ti ti-loader pe-2 spinning me-2"></i>
            <i v-else class="ti ti-download pe-2"></i>
            <span>Télécharger</span>
          </a>
        </div>
      </div>
    </div>

    <!-- List View -->
    <div v-else>
      <div class="gray-box d-block facture-box" v-for="item in factureClientStore.getFacturesClients" :key="item.PINO">
        <div class="row g-0 align-items-center justify-content-between">
          <div class="col-md-8">
            <p class="mb-1 dark-color font-15">{{ formatDate(item.PiDt) }}</p>
            <div class="d-flex gap-2 align-items-center mb-2">
              <i class="ti ti-receipt blue-color font-30"></i>
              <div class="gray-box-info">
                <p class="font-bold mb-0">{{ `Facture N° ${item.PIREF}` || `Facture N° ${item.PINO}` }}</p>
                <span class="font-bold">{{ formatPrice(item.TTCMT) }}€ TTC</span>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right">
            <a
              href="#"
              class="btn btn-outline-orange"
              :class="{ disabled: downloading[item.PINO] }"
              @click.prevent="downloadFactureClients(item.PINO, item.PREFPINO, item.PIREF || item.PINO)"
            >
              <i v-if="downloading[item.PINO]" class="ti ti-loader pe-2 spinning me-2"></i>
              <i v-else class="ti ti-download pe-2"></i>
              <span>Télécharger</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div
      v-if="factureClientStore.getFacturesClients.length"
      class="pagination mt-4 d-flex justify-content-center align-items-center"
    >
      <button
        @click="factureClientStore.changePage(factureClientStore.getCurrentPage - 1)"
        :disabled="factureClientStore.getCurrentPage === 1"
        class="pagination-btn prev"
      >
      
        <i class="ti ti-angle-left"></i>
        <span>Précédent</span>
      </button>
      <div class="pagination-content">
        <div class="pagination-btns mt-1">
          <button :class="['pagination-btn-numbers', 'mx-1', { active: true }]">
            {{ factureClientStore.getCurrentPage }}
          </button>
        </div>
        <span class="pagination-info"></span>
      </div>
      <button
        @click="factureClientStore.changePage(factureClientStore.getCurrentPage + 1)"
        :disabled="!factureClientStore.getHasMorePages"
        class="pagination-btn next"
      >
      <span>Suivant</span>
        <i class="ti ti-angle-right"></i>
      </button>
    </div>
  </div>
</template>

<script>
  import { ref } from "vue";
  import { useFactureClientStore } from "@/stores/factureClientStore";
  import { useToast } from "vue-toastification";

  export default {
    name: "FacturesView",
    setup() {
      const factureClientStore = useFactureClientStore();
      const view = ref("grid");
      const downloading = ref({});
      const toast = useToast();

      return { factureClientStore, view, downloading, toast };
    },
    methods: {
      formatDate(date) {
        if (!date) return "--";
        try {
          // Parse YYYYMMDDHHMMSS format
          const year = date.substring(0, 4);
          const month = date.substring(4, 6);
          const day = date.substring(6, 8);
          const parsedDate = new Date(`${year}-${month}-${day}`);
          if (isNaN(parsedDate)) return "--";
          return parsedDate.toLocaleDateString("fr-FR", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
        } catch (error) {
          console.error("Erreur lors du formatage de la date:", error);
          return "--";
        }
      },
      formatPrice(amount) {
        if (!amount && amount !== 0) return "0.00";
        return parseFloat(amount).toFixed(2);
      },
      async downloadFactureClients(pino, prefPino, piref) {
        this.downloading[pino] = true;
        try {
          await this.factureClientStore.downloadFactureClients(pino, prefPino, piref);
        } catch (error) {
          this.toast.error("Erreur lors du téléchargement de la facture");
        } finally {
          this.downloading[pino] = false;
        }
      },
      downloadAll() {
        console.log("Téléchargement de toutes les factures (à implémenter)");
      },
    },
    mounted() {
      this.factureClientStore.fetchFacturesClients();
    },
  };
</script>

<style scoped>
  .loading {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #666;
  }
  .alert-info {
    text-align: center;
    padding: 20px;
    font-size: 16px;
    color: #1e347d;
    background-color: #1e347d12;
    border: 1px solid #1e347d0a;
    border-radius: 4px;
  }
  .btn-outline-orange:hover {
    .orange-color {
      color: white !important;
    }
  }
  .btn-orange {
    color: white !important;
  }
  .icon-white {
    color: white !important;
  }
  .spinning {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid white;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .pagination-btn {
        border-radius: 10px;
        width: max-content;
        height: max-content;
  }
</style>
